module.exports = __webpack_public_path__ + "static/headerIcon-b5acab1058283b7e3a53d76c79b1ba8c.svg";